/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsSacFinderData } from './hosports-sac-finder.data';
import { IHosportsSacFinderProps } from './hosports-sac-finder.props.autogenerated';

export interface IHosportsSacFinderViewProps extends IHosportsSacFinderProps<IHosportsSacFinderData> {

}

/**
 *
 * HosportsSacFinder component
 * @extends {React.PureComponent<IHosportsSacFinderProps<IHosportsSacFinderData>>}
 */
class HosportsSacFinder extends React.PureComponent<IHosportsSacFinderProps<IHosportsSacFinderData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsSacFinder;
